import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logout as logoutApi } from '../api/auth.api';
import { getLoggedInUser } from "../api/auth.api";
import { useAuth } from "../context/AuthContext";

const Navbar = ({ openLogin, openRegister }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUser } = useAuth();

  const [hoverLogin, setHoverLogin] = useState(false);
  const [hoverRegister, setHoverRegister] = useState(false);
  const [hoverLogout, setHoverLogout] = useState(false);
  const [hoverCart, setHoverCart] = useState(false);
  const [hoverDashboard, setHoverDashboard] = useState(false);
  
  // State for suggestion item hover
  const [hoverSuggestion, setHoverSuggestion] = useState(null);

  const [search,setSearch] = useState("");
  const [suggestions,setSuggestions] = useState([]);
  const [showSuggestions,setShowSuggestions] = useState(false);

  // Logout Function
  const logout = async () => {
    await logoutApi();
    setUser(null);
    navigate('/');
  };

  useEffect(() => {
    if(!search){
      setSuggestions([]);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        const res = await fetch("http://localhost:5000/api/v1/buyer/products/search", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            match: search,
            per_page: 5
          })
        });

        const data = await res.json();

        setSuggestions(data.data[0].data || []);
        setShowSuggestions(true);

      } catch (e) {
        console.log(e);
      }
    }, 300);

    return () => clearTimeout(timer);

  }, [search]);



  return (
    <header
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      {/* Top Contact Bar - Hidden on extra-small screens */}
      <div
        className="d-none d-sm-flex justify-content-between px-4 py-2"
        style={{
          backgroundColor: '#112347',
          color: 'white',
          fontSize: '13px',
          fontWeight: '500',
        }}
      >
        <div>📞 +91 265 123 4567</div>
        <div>GST Compliant | Nationwide Delivery | ISO Certified</div>
      </div>

      {/* Main Navbar - Responsive for mobile */}
      <nav
        className="d-flex align-items-center px-2 px-md-4 py-2 py-md-3 bg-white border-bottom shadow-sm position-relative"
        style={{ zIndex: 1000, gap: "0.5rem", flexWrap: "nowrap" }}
      >
        {/* Logo Section */}
        <Link
          to="/"
          className="d-flex align-items-center gap-1 gap-md-2 text-decoration-none flex-shrink-0"
          style={{ minWidth: "auto" }}
        >
          <img
            src="\assets\logo.jpg" /*  logo */
            alt="Aeternitas Logo"
            className="rounded"
            style={{
              width: '35px',
              height: '35px',
              objectFit: 'cover', 
              flexShrink: 0
            }}
          />
          <div className="d-none d-sm-flex flex-column">
            <div
              style={{
                fontSize: "clamp(14px, 2.5vw, 18px)",
                fontWeight: '800',
                color: '#112347',
                letterSpacing: '0.5px',
                lineHeight: '1.1',
                whiteSpace: 'nowrap'
              }}
            >
              AETERNITAS
            </div>
            <div
              style={{
                fontSize: "clamp(8px, 1.5vw, 11px)",
                color: '#6b7280',
                fontWeight: '500',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap'
              }}
            >
              Material Handling
            </div>
          </div>
        </Link>

        {/* Search Bar Wrapper - Responsive - Only on home page */}
        {location.pathname === "/" && (
        <div
          className="search-wrapper-mobile"
          style={{
            position:"relative",
            flexGrow: 1,
            marginLeft: "20px",
            marginRight: "20px",
            minWidth: "120px",
            maxWidth: "100%",
          }}
        >
          <div
            className="d-flex align-items-center px-2 px-md-3 py-2 rounded"
            style={{
              backgroundColor: '#f3f4f6',
              border: '1px solid #e5e7eb',
              width: '100%'
            }}
            >
            <svg
              width="clamp(14px, 2vw, 18px)"
              height="clamp(14px, 2vw, 18px)"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#9ca3af"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>

           <input
              type="text"
              placeholder="Search by product name..."
              value={search}
              onChange={(e)=>{
                const val = e.target.value;
                setSearch(val);

                // send search to BuyerProducts (LIVE)
                window.dispatchEvent(
                  new CustomEvent("globalSearch", { detail: val })
                );
              }}
              onFocus={()=>setShowSuggestions(true)}
              onBlur={()=>setTimeout(()=>setShowSuggestions(false),200)}
              className="border-0 bg-transparent w-100 ms-2"
              style={{
                outline: 'none',
                fontSize: "clamp(12px, 1.5vw, 14px)",
                color: '#374151'
              }}
            />
          </div>

          {/* Styled Suggestions Dropdown */}
          {showSuggestions && suggestions.length > 0 && (
            <div 
              className="position-absolute shadow-lg border rounded-3 overflow-hidden"
              style={{
                top:"100%",
                left:0,
                right:0,
                background:"#fff",
                borderColor: "#e5e7eb",
                marginTop:"6px",
                zIndex: 2000,
                width: '100%'
              }}
            >
              {suggestions.map((item, i)=>(
                <div
                  key={i}
                  onMouseEnter={() => setHoverSuggestion(i)}
                  onMouseLeave={() => setHoverSuggestion(null)}
                  className="d-flex align-items-center gap-2 px-3 py-2"
                  style={{
                    cursor:"pointer",
                    backgroundColor: hoverSuggestion === i ? '#f9fafb' : 'white',
                    borderBottom: i !== suggestions.length - 1 ? "1px solid #f3f4f6" : "none",
                    transition: '0.2s',
                    color: hoverSuggestion === i ? '#112347' : '#4b5563',
                    fontSize: '14px',
                    fontWeight: hoverSuggestion === i ? '600' : '500'
                  }}
                  onClick={()=>{
                    setSearch(item.product_name);

                    // trigger global search
                    window.dispatchEvent(
                      new CustomEvent("globalSearch", { detail: item.product_name })
                    );

                    setShowSuggestions(false);
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={hoverSuggestion === i ? '#112347' : '#9ca3af'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" x1="16.65" y2="16.65"></line>
                  </svg>

                  {item.product_name}
                </div>
              ))}
            </div>
          )}
        </div>
        )}

        {/* Action Buttons */}
        <div
          className="d-flex align-items-center gap-1 gap-md-2 flex-shrink-0 ms-auto"
          style={{ minWidth: "auto" }}
        >
          {/* Cart Icon */}
          

          {/* Authentication Buttons */}
          {!user ? (
            <>
              {/* Desktop Buttons */}
              <div className="d-none d-sm-flex align-items-center gap-2">
                <button
                  onClick={openLogin}
                  onMouseEnter={() => setHoverLogin(true)}
                  onMouseLeave={() => setHoverLogin(false)}
                  className="d-flex align-items-center gap-1 gap-md-2 text-decoration-none rounded text-nowrap flex-shrink-0"
                  style={{
                    backgroundColor: hoverLogin ? '#FFCF33' : '#dbeafe',
                    color: '#1e40af',
                    padding: "6px 10px",
                    paddingRight: "12px",
                    fontWeight: '600',
                    fontSize: "clamp(11px, 2vw, 14px)",
                    border: 'none'
                  }}
                >
                  Login
                </button>

                <button
                  onClick={() => openRegister("SELLER")}
                  onMouseEnter={() => setHoverRegister(true)}
                  onMouseLeave={() => setHoverRegister(false)}
                  className="text-decoration-none rounded text-nowrap flex-shrink-0"
                  style={{
                    backgroundColor: hoverRegister ? '#f97316' : '#fb923c',
                    color: 'white',
                    padding: "6px 10px",
                    paddingRight: "12px",
                    fontWeight: '600',
                    fontSize: "clamp(11px, 2vw, 14px)",
                    border: 'none'
                  }}
                >
                  Become a Seller
                </button>
              </div>

              {/* Mobile Single Button */}
              <button
                className="d-flex d-sm-none align-items-center justify-content-center border"
                onClick={openLogin}
                style={{
                  width: "38px",
                  height: "38px",
                  backgroundColor: "transparent",
                  color: "black",
                  fontSize: "18px",
                  fontWeight: "600",
                  border:"none",
                  borderRadius: "4px",
                  padding: "10px",
                }}
              >
                ☰
              </button>
            </>
          ) : (
            <>
              {user?.role === 'ADMIN' && (
                <Link
                  to="/admin/dashboard"
                  onMouseEnter={() => setHoverDashboard(true)}
                  onMouseLeave={() => setHoverDashboard(false)}
                  className="text-decoration-none rounded text-nowrap flex-shrink-0"
                  style={{
                    backgroundColor: '#112347',
                    color: 'white',
                    padding: '8px 15px',
                    fontWeight: '600',
                    fontSize: "clamp(13px, 2vw, 14px)",
                    transition: '0.2s'
                  }}
                >
                  Dashboard
                </Link>
              )}

              {user?.role === 'SELLER' && (
                <Link
                  to="/seller/dashboard"
                  onMouseEnter={() => setHoverDashboard(true)}
                  onMouseLeave={() => setHoverDashboard(false)}
                  className="text-decoration-none rounded text-nowrap flex-shrink-0"
                  style={{
                    backgroundColor: '#112347',
                    color: 'white',
                    padding: '8px 15px',
                    fontWeight: '600',
                    fontSize: "clamp(13px, 2vw, 14px)",
                    transition: '0.2s'
                  }}
                >
                  Dashboard
                </Link>
              )}

              {user?.role === 'BUYER' && (
                <Link
                  to="/buyer/dashboard"
                  onMouseEnter={() => setHoverDashboard(true)}
                  onMouseLeave={() => setHoverDashboard(false)}
                  className="text-decoration-none rounded text-nowrap flex-shrink-0"
                  style={{
                    backgroundColor: '#112347',
                    color: 'white',
                    padding: '8px 15px',
                    fontWeight: '600',
                    fontSize: "clamp(13px, 2vw, 14px)",
                    transition: '0.2s'
                  }}
                >
                  Dashboard
                </Link>
              )}

              <button
                onClick={logout}
                onMouseEnter={() => setHoverLogout(true)}
                onMouseLeave={() => setHoverLogout(false)}
                className="border-0 rounded"
                style={{
                  backgroundColor: hoverLogout ? '#dc2626' : '#ef4444',
                  color: 'white',
                  padding: '8px 15px',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: '0.2s',
                }}
              >
                Logout
              </button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;